class UTParallaxItems {
  constructor() {
    this.doms = document.querySelectorAll('[data-role="ut-parallax-item"]');
    if (!this.doms.length) return;

    this.elms = [];

    this.doms.forEach((elm) => {
      this.elms.push(new UTParallaxItem({ elm }));
    });
  }
}

class UTParallaxItem {
  constructor({ elm }) {
    this.elm = elm;
    this.scrollPos = window.scrollY;
    this.speed = this.elm.dataset.spped || 0.1;
    this.elm.setAttribute('data-y', 0);

    window.addEventListener('scroll', () => {
      this.updateParallax();
    });
  }

  updateParallax() {
    const crScrollPos = window.scrollY;
    const delta = (crScrollPos - this.scrollPos) * this.speed;
    this.scrollPos = crScrollPos;
    const translateY = parseFloat(this.elm.getAttribute('data-y') || 0) + delta;
    this.elm.setAttribute('data-y', translateY);
    this.elm.style.transform = `translateY(${translateY}px)`;
  }
}

export default UTParallaxItems;
